export default __webpack_public_path__ + "static/media/ico_map.aa267a15.svg";